<!--
 * @Author: xiexp
 * @Description: 
 * @Date: 2022-08-27 19:55:21
 * @LastEditTime: 2022-11-11 11:37:46
 * @FilePath: \indiba-web-new\src\pages\pc\found_new.vue
-->
<template>
  <div class="section2">
    <div class="bg">
      <img
        class="bg-img"
        src="../../assets/img/black-vip-section2-bg.png"
        alt=""
      />
    </div>
    <div class="head">
      <div class="logo">
        <img src="../../assets/home/logo.png" alt="logo" />
      </div>
      <div class="nav">
        <ul>
          <li>
            <router-link to="/home#page3">关于INDIBA</router-link>
          </li>
          <li>
            <router-link to="/home#page4">产品方案</router-link>
          </li>
          <li>
            <a target="_blank">INDIBA资讯</a>
          </li>
          <li>
            <router-link to="">找到INDIBA</router-link>
          </li>
          <li>
            <router-link to="/china">INDIBA中国</router-link>
          </li>
          <li>
            <router-link to="/hall">名人堂</router-link>
          </li>
          <li>
            <router-link to="/black-vip-zone/#page1">黑金专区</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="right-content">
      <div class="right-content-title">
        <img src="../../assets/home/logo.png" alt="logo" />
        <img src="../../assets/img/black-vip-logo.png" alt="" />
      </div>
      <div class="right-content-title2">彻底改变对效率和性能的认知</div>
    </div>
    <div class="right-bottom">
      <div class="right-bottom-1">
        <!-- <img src="../../assets/img/black-vip-rect1.png" alt="" /> -->
        <div class="right-bottom-1-content">
            <div class="icon-wrap">
                <img style="max-width: 97px;height: 88px;" src="../../assets/img/guide-min.png" alt="">
                <img style="max-width: 102px;height: 68px;" src="../../assets/img/interface-min.png" alt="">
            </div>
            <div class="title">
                <span>3米操作导线</span>
                <span>2个RES操作接口</span>
            </div>
            
        </div>
      </div>
      <div class="right-bottom-2">
        <!-- <img src="../../assets/img/black-vip-rect2.png" alt="" /> -->
        <div class="right-bottom-2-content">
            <img style="max-width: 107px;height: 81px;" src="../../assets/img/tubro-min.png" alt="">
            <div class="title">
                <span>TUBRO MAX技术</span>
                <span>250W即时功率</span>
            </div>
        </div>
      </div>
      <div class="right-bottom-3">
        <!-- <img src="../../assets/img/black-vip-rect3.png" alt="" /> -->
        <div class="right-bottom-3-content">
            <img style="max-width: 79px;height: 45px;" src="../../assets/img/cell-boost-min.png" alt="">
            <div class="title">
                <span>Cell Boost 技术</span>
                
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Found",
};
</script>

<style lang="less" less="scoped">
// @import '~vue-simple-scrollbar/dist/vue-simple-scrollbar.css';
.section2 {
  position: relative;
  background-size: cover;
  height: 100%;
  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: black;
    .bg-img {
      width: 100%;
      height: 100%;
    }
  }
  .bg-color {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    //   height: 1124px;
    background-color: rgba(46, 89, 175, 0.85);
  }
  .head {
    display: flex;
    justify-content: space-around;
    z-index: 999;
    position: absolute;
    width: 100%;
    top: 4.8vh;
    .logo {
    }
    .nav {
      max-width: 860px;
      width: 46%;
      ul {
        width: 100%;
        display: flex;
        justify-content: space-around;
        height: 21px;
        /* font-size: 21px; */
        font-family: Microsoft YaHei;
        font-weight: 400;
        li {
          display: inline-block;
          a {
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
    .tel {
      margin-bottom: 0.5rem;
      a {
        font-size: 16px;
        font-family: Arial;
        font-weight: 400;
        color: #fff;
      }
    }
  }
  .right-content {
    position: absolute;
    top: 18vh;
    left: 68vw;
    width: 26vw;
    top: 18vh;
    right: 32px;
    .right-content-title {
      display: flex;
      justify-content: space-around;
      img {
        height: 28px;
        width: auto;
      }
    }
    .right-content-title2 {
      color: white;
      font-size: 24px;
      margin-top: 12px;
      text-align: right;
    }
  }
  .right-bottom {
    position: absolute;
    bottom: 0;
    right: 48px;
    display: flex;
    align-items: end;
    width: 52vw;
    min-width:600px;
    // height: 100%;
    justify-content: space-between;
    .right-bottom-1 {
      position: relative;
      min-width: 240px; /* 防止内容溢出破坏布局 */
      max-width: 18vw;
      background: url(../../assets/img/black-vip-rect1.png)  no-repeat;
      flex-grow: 1.2;
      background-size: 100% 100%;
      height: 52vh;
      .icon-wrap{
        display: flex;
        justify-content: space-around;
        padding: 22px;
      }
      .title{
        display: flex;
        flex-direction: column;
        align-items: center;
        color: white;
        font-size: 20px;
        span{
            padding:8px;
        }
      }
    }
    .right-bottom-2 {
      position: relative;
      min-width: 190px; /* 防止内容溢出破坏布局 */
      max-width: 15vw;
      background: url(../../assets/img/black-vip-rect2.png) no-repeat;
      flex-grow: 1;
      background-size: 100% 100%;
      height: 46vh;
      .right-bottom-2-content{
        padding: 22px;
        text-align: center;
        display: flex;
        align-items: center;
        flex-direction: column;
        .title{
        display: flex;
        flex-direction: column;
        align-items: center;
        color: white;
        font-size: 20px;
        span{
            padding:8px;
        }
      }
      }
    }
    .right-bottom-3 {
      position: relative;
      min-width: 190px; /* 防止内容溢出破坏布局 */
      background: url(../../assets/img/black-vip-rect3.png) no-repeat;
      flex-grow: 1;
      max-width: 15vw;
      background-size: 100% 100%;
      height: 38vh;
      .right-bottom-3-content{
        padding: 22px;
        text-align: center;
        display: flex;
        align-items: center;
        flex-direction: column;
        .title{
        display: flex;
        flex-direction: column;
        align-items: center;
        color: white;
        font-size: 20px;
        span{
            padding:8px;
        }
      }
      }
    }
  }
}
</style>
